import { Component, ViewEncapsulation } from '@angular/core';
import { TopIntentColumn, TopIntentColumnDef, TopIntentRow } from './models/reports';
import { topIntentColumns } from './utils';
import { ReportSortablePanelV3Base } from './report-sortable-panel-v3.base';

@Component({
  moduleId: module.id.toString(),
  selector: 'report-top-intents-panel-v3',
  templateUrl: './templates/report-sortable-panel-v3.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ReportTopIntentsPanelV3Component extends ReportSortablePanelV3Base<TopIntentRow> {
  title: string = 'Top Intents';
  columns: TopIntentColumnDef[] = topIntentColumns;
  labelColumnKey: string = TopIntentColumn.IntentName;
}
